// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDownloadOutlinedSvg from "@fishx/icons-svg/es/asn/PDownloadOutlined";
import FishxIcon from '../components/FishxIcon';

var PDownloadOutlined = function PDownloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDownloadOutlinedSvg
  }));
};

PDownloadOutlined.displayName = 'PDownloadOutlined';
export default React.forwardRef(PDownloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDownloadOutlined.js
// module id = 3350
// module chunks = 0